import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Sabbatical week day 3: Raining datatypes",
  "description": "",
  "published": "2011-12-29T00:00:00.000Z",
  "redirect_from": ["/blog/sabbatical-week-day-3-raining-datatypes/swizec/3293"],
  "categories": "Artificial intelligence, Data type, Functional programming, Haskell, Languages, Machine learning, Neural Networks, Programming, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`I’m taking a sabbatical week over the holidays. This week’s posts will serve as a sort of report of what I got up to the previous day instead of the usual schedule – wish me luck that I achieve even half of what I’d like to.`}</em></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/5479666205_e74e748bf0_m3.jpg",
        "alt": "Data Points",
        "title": "Data Points"
      }}></img></p>
    <p>{`As I sit here slowly sipping on my tea I realize it may have been an incredibly bad idea to stay up until 8am trying to convince `}<a parentName="p" {...{
        "href": "http://haskell.org",
        "title": "Haskell (programming language)"
      }}>{`Haskell`}</a>{`that I really honestly don't care about types as much as it seems to.`}</p>
    <p>{`It's really quite funny how weird a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Type_system",
        "title": "Type system"
      }}>{`statically typed language`}</a>{` feels after many years of dynamic languages. `}<em parentName="p">{`Yes, I know, this is a `}<a parentName="em" {...{
          "href": "http://en.wikipedia.org/wiki/Number",
          "title": "Number"
        }}>{`Numerical`}</a>{` and that is a `}<a parentName="em" {...{
          "href": "http://en.wikipedia.org/wiki/Floating_point"
        }}>{`Double`}</a>{`, figure it the fuck out man! It's not that difficult!`}</em>{` You'd think the hardest part about Haskell would be that it is incredibly strict about the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Functional_programming",
        "title": "Functional programming"
      }}>{`functional programming`}</a>{` thing, but no, here I am, having trouble with the most basic of concepts.`}</p>
    <p>{`But! I prevailed!`}</p>
    <p>{`I had in my hands `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/Personal-Runway/blob/master/implementation/window.hs"
      }}>{`a lovely algorithm`}</a>{` that can in theory perform rudimentary predictions of how my spending is going to behave in the next few days. During my morning exercise I realized the implementation doesn't actually do what I think it does, but hey, at least I have the algorithm figured out :)`}</p>
    <p>{`The idea is really quite simple:`}</p>
    <ol>
      <li parentName="ol">{`Smoothen data with a `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Moving_average",
          "title": "Moving average"
        }}>{`rolling average`}</a>{` (a 7 day window seems to produce the nicest curve)`}</li>
      <li parentName="ol">{`The first unknown `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Data_point",
          "title": "Data point"
        }}>{`data point`}</a>{` is simply the `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Expected_value",
          "title": "Expected value"
        }}>{`expected value`}</a>{` (weighed average) of the last few points`}</li>
      <li parentName="ol">{`Expand weighed average window to include the new data point`}</li>
      <li parentName="ol">{`Calculate next one`}</li>
      <li parentName="ol">{`Repeat for as long as it makes sense - the more into the future you go, the more wrong you are`}</li>
    </ol>
    <p>{`After reading a bunch of papers on data mining time series yesterday I realized that I'm thinking way too much into this. Sure `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Support_vector_machine",
        "title": "Support vector machine"
      }}>{`SVM`}</a>{`'s are the best at predicting financial time series and people have extremely good results with backpropagation neural networks - somehow - but I honestly don't need this complexity. I'm just making a simple tool for myself and it's more important to have `}<em parentName="p">{`some`}</em>{` result than the `}<em parentName="p">{`optimal`}</em>{` result.`}</p>
    <p>{`And either way, according to the papers a neural network is only marginally better than the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Sliding_window_protocol",
        "title": "Sliding window protocol"
      }}>{`sliding window`}</a>{` approach, and even then only when you're dealing with data when far-away points have a lot of impact on the future and/or there is a lot of repetition - none of which happens here.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.tbray.org/ongoing/When/201x/2011/12/27/Type-Systems"
        }}>{`Type-System Criteria`}</a>{` (tbray.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/sabbatical-week-day-2-i-fail-at-octave/swizec/3282"
        }}>{`Sabbatical week day 2: I fail at Octave`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/learning-me-a-haskell/swizec/3272"
        }}>{`Learning me a Haskell`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://ringingtrue.net/2011/12/27/non-sabbatical/"
        }}>{`Non-Sabbatical`}</a>{` (ringingtrue.net)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/8178445/how-to-insert-a-file-to-an-image-datatype-in-sql-server-2005"
        }}>{`How to insert a file to an Image datatype in sql2005`}</a>{` (stackoverflow.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=ce282cd2-9d04-4814-b93d-219c7e073a5d",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      